/**
 * Las etiquetas `tema_*` las pone un flujo de n8n sobre el CONTACTO, a partir del tema que
 * la IA del dashboard le asignó a cada conversación. Existen para elegir el público de una
 * campaña de WhatsApp.
 *
 * En una conversación no sirven: filtrar por ellas no devuelve nada, y si alguien las pone
 * a mano el dashboard cuenta la conversación como derivada (toma cualquier etiqueta de la
 * conversación como señal de derivación). Por eso se ocultan en los selectores de
 * conversación y siguen visibles en Contactos y en la campaña.
 */
export const CONTACT_TOPIC_LABEL_PREFIX = 'tema_';

export const isContactTopicLabel = title =>
  typeof title === 'string' && title.startsWith(CONTACT_TOPIC_LABEL_PREFIX);

export const withoutContactTopicLabels = labels =>
  (labels ?? []).filter(label => !isContactTopicLabel(label?.title));
